import type { Child } from "@/types";
import type {
  PublicFeeGetListRequest,
  PublicFeeGetListResponse,
  TypeNeedSelectItem,
} from "@/types";
import { apiGet, apiPost } from "./client";

const DEFAULT_PAGE_SIZE = 10;
const FEE_STATUS_ACTIVE = 3;

/**
 * Bolalar ro'yxatini sahifalab olish (real API).
 * Qatorlar API modeli bo'yicha Child[] qaytariladi (til UI da tanlanadi).
 */ 
export async function getChildrenList(params: {
  page: number;
  pageSize?: number;
  initData?: string | "";
  typeNeedId?: number;
  statusIds?: number[];
}): Promise<{ total: number; rows: Child[] }> {
  const payload: PublicFeeGetListRequest = {
    statusIds: params.statusIds ?? [FEE_STATUS_ACTIVE],
    ...(params.typeNeedId !== undefined && { typeNeedId: params.typeNeedId }),
    page: params.page,
    pageSize: params.pageSize ?? DEFAULT_PAGE_SIZE,
    initData: params.initData ?? "",
  };

  const res = await apiPost<PublicFeeGetListResponse>(
    "/MiniApp/GetFeeList",
    payload
  );
  return {
    total: res.total ?? 0,
    rows: (res.rows ?? []) as Child[],
  };
}

/**
 * Bitta bolani ID bo'yicha real API dan olish.
 * GET /MiniApp/GetFeeDetail/{id}
 */
export async function getChildByIdFromList(id: number): Promise<Child | null> {
  const res = await apiGet<Child | { data?: Child | null } | { row?: Child | null }>(
    `/MiniApp/GetFeeDetail/${id}`
  );
  if (!res) return null;
  if (typeof res === "object" && "data" in res) return res.data ?? null;
  if (typeof res === "object" && "row" in res) return res.row ?? null;
  return res as Child;
}

/**
 * TypeNeed filtri uchun select list (tablar).
 * GET /api/TypeNeed/GetAsSelectList
 */
export async function getTypeNeedSelectList(): Promise<TypeNeedSelectItem[]> {
  return apiGet<TypeNeedSelectItem[]>("/TypeNeed/GetAsSelectList");
}
